import { useCallback, useEffect, useState } from 'react';
import equal from 'fast-deep-equal';

import type { MutableRefObject } from 'react';

function useElemRect(ref: MutableRefObject<HTMLElement>): DOMRect {
  const [rect, setRect] = useState<DOMRect>(null);

  const handleResize = useCallback(() => {
    if (!ref.current) return;

    const newRect = ref.current.getBoundingClientRect();

    if (equal(rect, newRect)) return;

    setRect(newRect);
  }, [rect, ref]);

  useEffect(() => {
    handleResize();

    const intervalId = setInterval(() => {
      handleResize();
    }, 1000);

    return () => clearInterval(intervalId);
  }, [handleResize]);

  return rect;
}

export default useElemRect;
